"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypography = exports.BlocksTypographyVariables = exports.createFontFaceDirective = exports.assignVariablesToElement = exports.assignTokensToVariables = exports.baseElementHeadingsKeys = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@emotion/react");
var useTypography_1 = require("@cvent/carina/components/Typography/useTypography");
var useTheme_1 = require("@cvent/carina/components/ThemeProvider/useTheme");
var BreakpointsProvider_1 = require("@cvent/carina/components/Breakpoints/BreakpointsProvider");
var fonts_1 = require("../utils/fonts");
exports.baseElementHeadingsKeys = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
var baseElementsBodyKeys = [
    // 'span',
    'p',
    'ol',
    'ul'
];
var baseElementKeys = exports.baseElementHeadingsKeys.concat(baseElementsBodyKeys);
var monoElementKeys = ['pre', 'code'];
var assignTokensToVariables = function (tokens, elementKey, fontFamily) {
    if (tokens === null || tokens === void 0 ? void 0 : tokens[elementKey]) {
        return "\n      --blocks-".concat(elementKey, "-color: ").concat(tokens[elementKey].color, ";\n      --blocks-").concat(elementKey, "-font-family: ").concat(fontFamily, ";\n      --blocks-").concat(elementKey, "-font-size: ").concat(tokens[elementKey].fontSize, ";\n      --blocks-").concat(elementKey, "-font-weight: ").concat(tokens[elementKey].fontWeight, ";\n      --blocks-").concat(elementKey, "-line-height: ").concat(tokens[elementKey].lineHeight, "; \n    ");
    }
    return '';
};
exports.assignTokensToVariables = assignTokensToVariables;
var assignVariablesToElement = function (elementKey) { return "\n  ".concat(elementKey, " {\n    color: var(--blocks-").concat(elementKey, "-color);\n    font-family: var(--blocks-").concat(elementKey, "-font-family);\n    font-size: var(--blocks-").concat(elementKey, "-font-size);\n    font-weight: var(--blocks-").concat(elementKey, "-font-weight);\n    line-height: var(--blocks-").concat(elementKey, "-line-height);\n  }\n"); };
exports.assignVariablesToElement = assignVariablesToElement;
var createFontFaceDirective = function (font) {
    if (font === null || font === void 0 ? void 0 : font.styles) {
        return font.styles
            .map(function (fontStyle) {
            var _a;
            return "\n    @font-face {\n      font-family: '".concat(font.name, "';\n      font-style: ").concat(fontStyle.style, ";\n      font-weight: ").concat(fontStyle.weight, ";\n      font-display: swap;\n      src: url(").concat(fontStyle.url, ") format('").concat((_a = fontStyle.format) !== null && _a !== void 0 ? _a : (0, fonts_1.getFontFormat)(fontStyle.url), "');\n    }\n    ");
        })
            .join('\n');
    }
    return '';
};
exports.createFontFaceDirective = createFontFaceDirective;
function BlocksTypographyVariables(_a) {
    var headingFont = _a.headingFont, bodyFont = _a.bodyFont, typographyClassName = _a.typographyClassName;
    var _b = (0, useTypography_1.useTypography)(), base = _b.base, mono = _b.mono;
    var className = typographyClassName ? ".".concat(typographyClassName) : ':root';
    var styles = (0, react_2.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", " {\n      ", "\n      ", "\n      ", "\n      ", "\n      ", "\n    }\n\n    ", "\n  "], ["\n    ", " {\n      ", "\n      ", "\n      ", "\n      ", "\n      ", "\n    }\n\n    ", "\n  "])), className, exports.baseElementHeadingsKeys.map(function (elementKey) { var _a; return (0, exports.assignTokensToVariables)(base, elementKey, (0, fonts_1.getFontFamily)((_a = base === null || base === void 0 ? void 0 : base[elementKey]) === null || _a === void 0 ? void 0 : _a.fontFamily, headingFont)); }), baseElementsBodyKeys.map(function (elementKey) { var _a; return (0, exports.assignTokensToVariables)(base, elementKey, (0, fonts_1.getFontFamily)((_a = base === null || base === void 0 ? void 0 : base[elementKey]) === null || _a === void 0 ? void 0 : _a.fontFamily, bodyFont)); }), monoElementKeys.map(function (elementKey) { var _a; return (0, exports.assignTokensToVariables)(mono, elementKey, (0, fonts_1.getFontFamily)((_a = base === null || base === void 0 ? void 0 : base[elementKey]) === null || _a === void 0 ? void 0 : _a.fontFamily, null)); }), (0, exports.createFontFaceDirective)(headingFont), (0, exports.createFontFaceDirective)(bodyFont), __spreadArray(__spreadArray([], __read(baseElementKeys), false), __read(monoElementKeys), false).map(function (elementKey) { return (0, exports.assignVariablesToElement)(elementKey); }));
    return (0, jsx_runtime_1.jsx)(react_2.Global, { styles: styles });
}
exports.BlocksTypographyVariables = BlocksTypographyVariables;
function useTypography() {
    var _a, _b;
    var _c = (0, useTypography_1.useTypography)(), html = _c.html, body = _c.body, base = _c.base, mono = _c.mono;
    var _d = (0, useTheme_1.useTheme)(), font = _d.font, block = _d.block;
    var m = (0, BreakpointsProvider_1.useBreakpoints)().m;
    var styles = (0, react_1.useMemo)(function () {
        var _a;
        var mediaIsSmallAndBelow = "@media (max-width: ".concat(m - 1, "px)");
        return [
            (0, react_2.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", "\n        ", "\n        ", "\n      "], ["\n        ", "\n        ", "\n        ", "\n      "])), exports.baseElementHeadingsKeys.map(function (elementKey) { var _a, _b; return (0, exports.assignTokensToVariables)(base, elementKey, ((_b = (_a = block === null || block === void 0 ? void 0 : block.font) === null || _a === void 0 ? void 0 : _a.headings) === null || _b === void 0 ? void 0 : _b.fontFamily) || font.base.family); }), baseElementsBodyKeys.map(function (elementKey) { return (0, exports.assignTokensToVariables)(base, elementKey, font.base.family); }), monoElementKeys.map(function (elementKey) { return (0, exports.assignTokensToVariables)(mono, elementKey, mono[elementKey].fontFamily); })),
            __assign(__assign(__assign({}, html), body), (_a = { fontSize: font.base.size[4], fontWeight: font.base.weight.regular, 
                    // Variable overrides 👇
                    // h1
                    '--blocks-h1-font-size': font.base.size[9], '--blocks-h1-font-weight': font.base.weight.bold, 
                    // h2
                    '--blocks-h2-font-size': '1.75rem', '--blocks-h2-font-weight': 600, 
                    // h3
                    '--blocks-h3-font-size': '1.3125rem', '--blocks-h3-font-weight': 600, 
                    // h4
                    '--blocks-h4-font-size': font.base.size[5], '--blocks-h4-font-weight': 600, 
                    // h5
                    '--blocks-h5-font-size': font.base.size[4], '--blocks-h5-font-weight': 600, 
                    // h6
                    '--blocks-h6-font-size': font.base.size[3], '--blocks-h6-font-weight': 600, 
                    // p
                    '--blocks-p-font-size': font.base.size[4], 
                    // ol
                    '--blocks-ol-font-size': font.base.size[4], 
                    // ul
                    '--blocks-ul-font-size': font.base.size[4] }, _a[mediaIsSmallAndBelow] = {
                fontSize: font.base.size[3],
                // h1
                '--blocks-h1-font-size': '1.75rem',
                // h2
                '--blocks-h2-font-size': '1.375rem',
                // h3
                '--blocks-h3-font-size': font.base.size[6],
                // p
                '--blocks-p-font-size': font.base.size[3],
                // ol
                '--blocks-ol-font-size': font.base.size[3],
                // ul
                '--blocks-ul-font-size': font.base.size[3]
            }, _a))
        ];
    }, [
        html,
        body,
        font.base.size,
        font.base.weight,
        font.base.family,
        base,
        (_b = (_a = block === null || block === void 0 ? void 0 : block.font) === null || _a === void 0 ? void 0 : _a.headings) === null || _b === void 0 ? void 0 : _b.fontFamily,
        mono,
        m
    ]);
    return styles;
}
exports.useTypography = useTypography;
var templateObject_1, templateObject_2;
//# sourceMappingURL=BlocksTypography.js.map